import React, { useState, useEffect } from "react"
import axios from "axios"
import classNames from "classnames"

import {
  Row,
  Col,
  Card,
  CardBody,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Pagination,
  PaginationItem,
  PaginationLink,
  ButtonDropdown,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"

import styled from "styled-components"

const FilterTxt = styled.input`
  width: 224px;
  margin-left: 5px;
`

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

const GoalType = () => {
  // GET

  const [refresh, setRefresh] = useState(0)
  const [data, setData] = useState([])
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/goal-type/get`)
      .then(res => {
        setData(res.data)
      })
      .catch(err => console.log(err))
  }, [refresh])

  // ADD
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  })
  const { name, description } = formData
  const handleChangeStatus = e => {
    setFormData(data => ({ ...data, status: e.target.value }))
  }
  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }
  const handleSubmit = e => {
    e.preventDefault()
    if (name && description) {
      axios
        .put(`${process.env.REACT_APP_API_URL}/api/goal-type/add`, formData)
        .then(res => {
          setData([...data, res.data])
          setFormData({
            name: "",
            description: "",
          })
          setmodalAdd(!modalAdd)
          removeBodyCss()
        })
        .catch(err => console.log(err))
    }
  }

  // EDIT

  const [selectedItem, setSelectedItem] = useState()

  const handleEditChange = e => {
    const { name, value } = e.target
    if (name === "status")
      return setSelectedItem(selected => ({ ...selected, status: value }))
    setSelectedItem(selected => ({ ...selected, [name]: value }))
  }

  const handleEdit = goaltype => {
    setSelectedItem({ ...goaltype })
    toggleEdit()
  }

  const handleUpdate = () => {
    const { goal_type_id, name, description, status } = selectedItem

    const reqForm = {
      goal_type_id,
      name,
      description,
      status: status.toString(),
    }

    if (name && description) {
      axios
        .put(`${process.env.REACT_APP_API_URL}/api/goal-type/edit`, reqForm)
        .then(res => {
          toggleEdit()
          setRefresh(refresh + 1)
        })
        .catch(err => console.log(err))
    }
  }

  const removeBodyCss = () => {
    document.body.classList.add("no_padding")
  }

  const [drp_secondary, setDrp_secondary] = useState(false)
  const [modalDelete, setmodalDelete] = useState(false)
  const [modalEdit, setmodalEdit] = useState(false)
  const [modalAdd, setmodalAdd] = useState(false)

  const toggleAdd = () => {
    setFormData(data => ({ ...data, status: "1" }))
    setmodalAdd(!modalAdd)
    removeBodyCss()
  }

  const toggleEdit = () => {
    setmodalEdit(!modalEdit)
    removeBodyCss()
  }

  const toggleDelete = () => {
    setmodalDelete(!modalDelete)
    removeBodyCss()
  }

  document.title = "Goal | Goal Type"
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            maintitle="HRIS"
            title="MAIN"
            breadcrumbItem="Goal Type"
          />
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <Row className="mb-3">
                    <h2>Goal Type</h2>
                  </Row>
                  <hr />
                  <Row>
                    <Col lg={3}>
                      <FilterTxt
                        name="search"
                        type="text"
                        className="form-control w-100 h-100"
                        placeholder="Search..."
                      />
                    </Col>
                    <Col lg={5}>
                      <div className="btn-group mt-1">
                        <ButtonDropdown
                          isOpen={drp_secondary}
                          toggle={() => setDrp_secondary(!drp_secondary)}
                        >
                          <DropdownToggle
                            tag="button"
                            className="btn btn-outline-info"
                          >
                            <i
                              className="typcn typcn-th-list"
                              style={{ fontSize: "18px" }}
                            />{" "}
                            Select Status <i className="mdi mdi-chevron-down" />
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem>Active</DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem>Inactive</DropdownItem>
                          </DropdownMenu>
                        </ButtonDropdown>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                        <Button
                          onClick={toggleAdd}
                          size="md"
                          color="primary"
                          className="waves-effect waves-light mt-2"
                        >
                          {" "}
                          <i
                            className="typcn typcn-folder-add"
                            style={{ fontSize: "18px" }}
                          ></i>{" "}
                          Add New
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  {/* ADD MODAL */}
                  <Modal
                    isOpen={modalAdd}
                    toggle={toggleAdd}
                    centered
                    size="lg"
                  >
                    <ModalHeader className="mt-0" toggle={toggleAdd}>
                      Create Goal Type
                    </ModalHeader>
                    <ModalBody className="m-2">
                      <Row className="mb-3">
                        <label className="col-md-2 col-form-label">
                          Goal Type
                        </label>
                        <div className="col-md-10 mb-2">
                          <input
                            className="form-control"
                            type="text"
                            id="department_name"
                            placeholder="Enter Goal Type"
                            name="name"
                            value={name}
                            onChange={handleChange}
                          />
                        </div>
                      </Row>
                      <Row className="mb-3">
                        <label className="col-md-2 col-form-label">
                          Description
                        </label>
                        <div className="col-md-10 mb-2">
                          <textarea
                            id="description"
                            name="description"
                            rows="4"
                            className="form-control"
                            placeholder="Enter Goal Type Description"
                            value={description}
                            onChange={handleChange}
                          ></textarea>
                        </div>
                      </Row>
                      <Row className="mt-3">
                        <label
                          htmlFor="status"
                          className="col-md-2 col-form-label"
                        >
                          Status
                        </label>
                        <div className="col-md-10 mb-2">
                          <select
                            className="form-control"
                            onChange={handleChangeStatus}
                          >
                            <option name="status" value={1}>
                              Active
                            </option>
                          </select>
                        </div>
                      </Row>
                    </ModalBody>
                    <ModalFooter>
                      <Button color="primary" onClick={handleSubmit}>
                        Add
                      </Button>
                      <Button color="secondary" onClick={toggleAdd}>
                        Close
                      </Button>{" "}
                    </ModalFooter>
                  </Modal>

                  {/* EDIT MODAL */}
                  <Modal
                    isOpen={modalEdit}
                    toggle={toggleEdit}
                    centered
                    size="lg"
                  >
                    <ModalHeader className="mt-0" toggle={toggleEdit}>
                      Edit Goal Type
                    </ModalHeader>
                    <ModalBody className="m-2">
                      <Row className="mb-3">
                        <label className="col-md-2 col-form-label">
                          Goal Type
                        </label>
                        <div className="col-md-10 mb-2">
                          <input
                            type="text"
                            className="form-control"
                            id="name"
                            name="name"
                            value={selectedItem?.name || ""}
                            onChange={handleEditChange}
                          />
                        </div>
                      </Row>
                      <Row className="mb-3">
                        <label className="col-md-2 col-form-label">
                          Description
                        </label>
                        <div className="col-md-10 mb-2">
                          <textarea
                            id="description"
                            name="description"
                            rows="4"
                            className="form-control"
                            value={selectedItem?.description || ""}
                            onChange={handleEditChange}
                          ></textarea>
                        </div>
                      </Row>
                      <Row className="mt-3">
                        <label
                          htmlFor="example-date-input"
                          className="col-md-2 col-form-label"
                        >
                          Status
                        </label>
                        <div className="col-md-10 mb-2">
                          <select
                            className="form-control"
                            name="status"
                            value={selectedItem?.status}
                            onChange={handleEditChange}
                          >
                            <option disabled>--- Select Status ---</option>
                            <option value={"1"}>Active</option>
                            <option value={"0"}>Inactive</option>
                          </select>
                        </div>
                      </Row>
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="primary"
                        onClick={() => {
                          handleUpdate()
                        }}
                      >
                        Save changes
                      </Button>
                      <Button color="secondary" onClick={toggleEdit}>
                        Close
                      </Button>{" "}
                    </ModalFooter>
                  </Modal>

                  {/* DELETE MODAL */}

                  <Col sm={6} md={4} xl={3}>
                    <Modal isOpen={modalDelete} toggle={toggleDelete} centered>
                      <ModalHeader className="mt-0" toggle={toggleDelete}>
                        Are you sure want to delete Goal Type?
                      </ModalHeader>
                      <div className="modal-footer">
                        <button type="button" className="btn btn-danger">
                          Delete
                        </button>
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={toggleDelete}
                        >
                          Close
                        </button>
                      </div>
                    </Modal>
                  </Col>

                  <hr />
                  <div className="table-responsive">
                    <table className="table table-hover table-centered table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th scope="col">Type</th>
                          <th scope="col">Description</th>
                          <th scope="col">Status</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((item, index) => (
                          <tr key={index}>
                            <td>{item.name}</td>
                            <td>{item.description}</td>
                            <th>
                              <span
                                className={classNames("badge", {
                                  "bg-success": item.status === 1,
                                  "bg-danger": item.status === 0,
                                })}
                                style={{ width: "60px" }}
                              >
                                {item.status === 1 ? "Active" : "Inactive"}
                              </span>
                            </th>
                            <th>
                              <i
                                onClick={() => {
                                  handleEdit(item)
                                }}
                                className="typcn typcn-edit"
                                style={{ fontSize: "25px" }}
                              ></i>{" "}
                              <i
                                onClick={toggleDelete}
                                className="typcn typcn-trash"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </th>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
                <Pagination
                  aria-label="Page navigation example"
                  listClassName="justify-content-center"
                >
                  <PaginationItem disabled>
                    <PaginationLink href="#" tabIndex="-1">
                      Previous
                    </PaginationLink>
                  </PaginationItem>
                  <PaginationItem>
                    <PaginationLink href="#">1</PaginationLink>
                  </PaginationItem>
                  <PaginationItem active>
                    <PaginationLink href="#">2</PaginationLink>
                  </PaginationItem>
                  <PaginationItem>
                    <PaginationLink href="#">3</PaginationLink>
                  </PaginationItem>
                  <PaginationItem>
                    <PaginationLink href="#">Next</PaginationLink>
                  </PaginationItem>
                </Pagination>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default GoalType
